import request from '../../../../../helpers/request';

export const fetchForm = async (act, requestIds) => {
  const { url, name } = act;

  const start = requestIds[0];
  const end = requestIds[requestIds.length - 1];

  const data = await request.get(
    url,
    { requestIds },
    `Не удалось получить файл ${name}_${start}-${end}`,
    undefined,
    undefined,
    'comma'
  );

  return data;
};
